import type { ISpacesService } from './services/SpacesService'
import { LoaderPage } from '../common/react/ui/LoaderPage.tsx'
import SpacesHomePage from './SpacesHomePage.tsx'
import { useDiRef } from '../common/react/di-hooks'
import { useBehaviorObservable } from '../common/react/observable-hooks'

export function SpaceHomePageContainer() {
  const spacesService = useDiRef<ISpacesService>('SpacesService')
  const spaces = useBehaviorObservable(spacesService.spaces$)

  if (!spaces) {
    return <LoaderPage />
  }

  return <SpacesHomePage />
}

export default SpaceHomePageContainer
